import { AxiosRequestConfig } from 'axios';

import { httpApiClient } from 'configs/http-client';
import { GetListPayload, MetaPage } from 'interfaces';
import {
  CustomMailEntitiesResponse,
  CustomMailRecipient,
  CustomMailTemplate,
  CustomMailTypesResponse,
  CustomMailSendingPayload,
  CountriesResponse,
  CustomMailSent,
} from 'interfaces/custom-mail';
import { stringifyFilterParams } from 'utils';

export class CustomMailApi {
  constructor(private url: string) {}

  getMailTypes(config?: AxiosRequestConfig) {
    return httpApiClient.get<CustomMailTypesResponse>(`${this.url}/types`, config);
  }

  getEntities(config?: AxiosRequestConfig) {
    return httpApiClient.get<CustomMailEntitiesResponse>(`${this.url}/entities`, config);
  }

  getCustomMailTemplate(config?: AxiosRequestConfig) {
    return httpApiClient.get<{ data: CustomMailTemplate }>(`${this.url}/template`, config);
  }

  getCustomMailEntityMembers(entity: string, params: GetListPayload, config?: AxiosRequestConfig) {
    return httpApiClient.get<{ data: CustomMailRecipient[]; meta: MetaPage }>(
      `${this.url}/find-by-entity?entity=${entity}&${stringifyFilterParams(params)}`,
      config,
    );
  }

  getCustomMailUsers(entity: string, params: GetListPayload, config?: AxiosRequestConfig) {
    return httpApiClient.get<{ data: CustomMailRecipient[]; meta: MetaPage }>(
      `${this.url}/find-users?entity=${entity}&${stringifyFilterParams(params)}`,
      config,
    );
  }

  customMailSending(data: CustomMailSendingPayload, config?: AxiosRequestConfig) {
    return httpApiClient.post<{ data: CustomMailSendingPayload }>(`${this.url}/send`, data, config);
  }

  getCountryList(config?: AxiosRequestConfig) {
    return httpApiClient.get<CountriesResponse>(`${this.url}/countries`, config);
  }

  getCustomMailSent(params: GetListPayload, config?: AxiosRequestConfig) {
    return httpApiClient.get<{ data: CustomMailSent[]; meta: MetaPage }>(
      `${this.url}/sent?${stringifyFilterParams(params)}`,
      config,
    );
  }
}

export const customMailApi = new CustomMailApi('/admin/custom-mail');
